<template>
<div style="background-color:#e4e4e4" class="pa-1">
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="filteredGridRows"
    :search="search"
    sort-by="acct"
    class="elevation-1"
    dense
    show-select
    fixed-header
    height="60vh"
    :items-per-page="50"
    :footer-props="footerProps"
    :loading="loadTable"
    loading-text="Ачааллаж байна... Түр хүлээнэ үү!"
    no-data-text="Мэдээлэл байхгүй байна."
    no-results-text="Тохирох үр дүн олдсонгүй. Та дахин хайна уу?"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Төлбөр тооцоо</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-switch
          v-model="isActive"
          label="Идэвхитэй данс"
          color="success"
          value="true"
          hide-details
        ></v-switch>
        <v-col cols="12" sm="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Хайлт"
            rounded
            filled
            background-color="blue lighten-5"
            clearable
            hide-details
          ></v-text-field>
        </v-col>

        <!-- Print (start) -->
        <v-btn
          color="warning lighten-2"
          dark
          class="mb-2 mr-2"
          @click="wholePrint()"
        >
          Print <i class="mdi mdi-printer" aria-hidden="true"></i>
        </v-btn>
        <!-- Print (end) -->

        <!-- Export (start) -->
        <vue-json-csv
          class="btn btn-default"
          :data="filteredGridRows"
          :fields="export_fields"
          :labels="export_labels"
          name="payments.csv"
        >
          <v-btn color="error lighten-2" dark class="mb-2 mr-2">
            Export <i class="mdi mdi-export-variant" aria-hidden="true"></i>
          </v-btn>
        </vue-json-csv>
        <!-- Export (end) -->

        <v-dialog
          v-model="dialog"
          max-width="800px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="green lighten-2"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              нэмэх
              <v-icon small class="ml-1">mdi-plus-thick</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline green lighten-2" primary-title>
              {{ formTitle }}
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form">
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-btn
                      color="primary lighten-2"
                      dark
                      @click="dialog2 = !dialog2"
                    >
                      Хэрэглэгчийн мэдээлэл сонгох
                      <v-icon>mdi-arrow-bottom-right-thin-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.lastname"
                      label="Овог *"
                      :rules="[required]"
                      outlined
                      dense
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.firstname"
                      label="Нэр *"
                      :rules="[required]"
                      outlined
                      dense
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Утас *"
                      :rules="[required]"
                      outlined
                      dense
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.email"
                      label="Имэйл *"
                      :rules="[required]"
                      outlined
                      dense
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.request_dt"
                          label="Хүсэлтийн огноо *"
                          :rules="[required]"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.request_dt"
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.service_dt"
                          label="Эхлэх огноо *"
                          :rules="[required]"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.service_dt"
                        @input="menu3 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-menu
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.valid_dt"
                          label="Дуусах огноо *"
                          :rules="[required]"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.valid_dt"
                        @input="menu4 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <v-text-field
                      v-model="editedItem.amount"
                      label="Төлсөн дүн *"
                      :rules="[required]"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.discount_rate"
                      label="Хөнгөлөлтийн хувь"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.discount_amount"
                      label="Хөнгөлөлтийн дүн"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.org_limit"
                      label="Эрхийн тоо *"
                      :rules="[required]"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="9"
                    md="9"
                  >
                    <v-text-field
                      v-model="editedItem.notes"
                      label="Тэмдэглэл"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4 style="color:red">* Заавал бөглөх талбар</h4>
                </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Цуцлах
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Хадгалах
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialog2"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Хэрэглэгчийн мэдээлэл сонгох хэсэг
            </v-card-title>
            <v-card-text>
              <v-autocomplete
                :items="users"
                label="Хэрэглэгч"
                item-text="email"
                return-object
                no-data-text="Тохирох утга олдсонгүй!"
                v-on:input="selectedUser"
              >
                <template slot="item" slot-scope="data">
                  {{data.item.lastname}} {{data.item.firstname}} ({{data.item.email}})
                </template>
              </v-autocomplete>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="dialog2 = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          persistent
          no-click-animation
          v-model="dialogDelete"
          width="500"
        >
          <template v-slot:activator="{ click }">
          <v-btn
            slot="activator"
            color="red lighten-2"
            dark
            class="mb-2 ml-2"
            @click="deleteItem"
          >
            Устгах
            <v-icon small class="ml-1">mdi-delete</v-icon>
          </v-btn>
          </template>
        
          <v-card>
            <v-card-title
              class="headline red lighten-2"
              primary-title
            >
              Мэдээллийг устгах уу?
            </v-card-title>
    
            <v-card-text>
              Сонгогдсон төлбөрийн мэдээллийг устгахад итгэлтэй байна уу?
              <br>Дахин сэргээх боломжгүйг анхаарна уу.
            </v-card-text>
    
            <v-divider></v-divider>
    
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="closeDelete"
              >
                Үгүй
              </v-btn>
              <v-btn
                color="primary darken-1"
                text
                @click="deleteItemConfirm"
              >
                Тийм
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
    </template>

    <template v-slot:header="{ header }">
      <tr class="grey lighten-3">
        <th style="border-right: 1px solid #c8c8c8">
          <v-icon>mdi-filter-variant</v-icon>
				</th>
        <th style="border-right: 1px solid #c8c8c8" v-for="header in headers" :key="header.text">
          <div v-if="filters.hasOwnProperty(header.value)">
            <v-autocomplete
              flat
              hide-details
              multiple
              attach
              chips
              dense
              clearable
              :items="columnValueList(header.value)"
              v-model="filters[header.value]"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 5">
                  <span> 
                    {{ item }} 
                  </span>
                </v-chip>
                <span v-if="index === 5" class="grey--text caption" > 
                  (+{{ filters[header.value].length - 5 }} others) 
                </span>
              </template>
            </v-autocomplete>
          </div>
          <div v-if="!filters.hasOwnProperty(header.value)">
            <v-icon>mdi-filter-variant</v-icon>
          </div>
        </th>
      </tr>
    </template>
 
    <template v-slot:item.amount="{ item }">
      <span>{{formatPrice(item.amount)}}</span>
    </template>
    <template v-slot:item.discount_rate="{ item }">
      <span>{{formatPrice(item.discount_rate)}}</span>
    </template>
    <template v-slot:item.discount_amount="{ item }">
      <span>{{formatPrice(item.discount_amount)}}</span>
    </template>
    <template v-slot:item.org_limit="{ item }">
      <span>{{formatPrice(item.org_limit)}}</span>
    </template>

    <template v-slot:body.append>
      <tr class="bold--text">
        <th />
        <th />
        <th colspan="4" class="text-left">НИЙТ ДҮН</th>
        <th />
        <th class="text-right">{{ formatPrice(sumField('amount')) }}</th>
        <th />
        <th class="text-right">{{ formatPrice(sumField('discount_amount')) }}</th>
        <th />
        <th />
      </tr>
    </template>

    <template v-slot:item.no = "{ index }">
      {{ index + 1 }}
    </template>
    
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
    </template>

    <template v-slot:no-data>
    </template>
  </v-data-table>
</div>
</template>

<script>
  import axios from 'axios';
  // import { required, minLength, between } from 'vuelidate/lib/validators';

  let bgColorCode = "orange lighten-5";
  export default {
    data: () => ({
      footerProps: {'items-per-page-options': [10, 20, 50, 100, -1]},
      pagination: {
        sortBy: 'name'
      },
      dialog: false,
      dialog2: false,
      dialogDelete: false,
      menu2: false,
      menu3: false,
      menu4: false,
      search: '',
      selected: [],
      accts1: [],
      accts2: [],
      users: [],
      loadTable: true,
      isActive: false,
      headers: [
        {
          text: '№',
          align: 'center',
          sortable: false,
          value: 'no',
          divider: true, 
          class: bgColorCode,
          width: '1%'
        },
        { text: 'Хэрэглэгч', value: 'user_nm', divider: true, class: bgColorCode, align: 'center', width: '150px' },
        { text: 'Утас', value: 'user_phone', divider: true, class: bgColorCode, align: 'center', width: '80px' },
        { text: 'Хүсэлт', value: 'request_dt', divider: true, class: bgColorCode, align: 'center', width: '105px' },
        { text: 'Эхлэх', value: 'service_dt', divider: true, class: bgColorCode, align: 'center', width: '105px' },
        { text: 'Дуусах', value: 'valid_dt', divider: true, class: bgColorCode, align: 'right', width: '105px' },
        { text: 'Мөнгөн дүн', value: 'amount', divider: true, class: bgColorCode, align: 'right', width: '100px' },
        { text: 'Хөнгөлөх хувь', value: 'discount_rate', divider: true, class: bgColorCode, align: 'right', width: '60px' },
        { text: 'Хөнгөлөх дүн', value: 'discount_amount', divider: true, class: bgColorCode, align: 'right', width: '100px' },
        { text: 'Эрхийн тоо', value: 'org_limit', divider: true, class: bgColorCode, align: 'right', width: '50px' },
        { text: 'Төлөв', value: 'status', divider: true, class: bgColorCode, align: 'right', width: '50px' },
        { text: 'Тайлбар', value: 'notes', divider: true, class: bgColorCode, align: 'left' },
        { text: 'Үйлдэл', value: 'actions', sortable: false, divider: false, class: bgColorCode, align: 'center', width: '1%' },
      ],
      export_fields: [
        'no', 'user_nm', 'user_phone', 'request_dt', 'service_dt', 'valid_dt',
        'amount', 'discount_rate', 'discount_amount', 'org_limit', 'status', 'notes'
      ],
      export_labels: {
        no: '№',
        user_nm: 'Хэрэглэгч',
        user_phone: 'Утас',
        request_dt: 'Хүсэлт',
        service_dt: 'Эхлэх',
        valid_dt: 'Дуусах',
        amount: 'Мөнгөн дүн',
        discount_rate: 'Хөнгөлөх хувь',
        discount_amount: 'Хөнгөлөх дүн',
        org_limit: 'Эрхийн тоо',
        status: 'Төлөв',
        notes: 'Тайлбар'
      },
      filters: {
        user_nm: [],
				user_phone: [],
				request_dt: [],
				service_dt: [],
				valid_dt: [],
				amount: [],
        discount_rate: [],
				discount_amount: [],
				org_limit: [],
        status: [],
				notes: [],
			},
      gridRows: [],
      editedIndex: -1,
      editedItem: {
        lastname: '',
				firstname: '',
				phone: '',
				email: '',
				request_dt: new Date().toISOString().substr(0, 10),
				service_dt: new Date().toISOString().substr(0, 10),
				valid_dt: '',
				amount: '',
        discount_rate: '',
				discount_amount: '',
				org_limit: '3',
				notes: '',
        user_id: ''
      },
      defaultItem: {
        lastname: '',
				firstname: '',
				phone: '',
				email: '',
				request_dt: new Date().toISOString().substr(0, 10),
				service_dt: new Date().toISOString().substr(0, 10),
				valid_dt: '',
				amount: '',
        discount_rate: '',
				discount_amount: '',
				org_limit: '3',
				notes: '',
        user_id: ''
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Шинээр төлбөр бүртгэх' : 'Төлбөрийн мэдээлэл засах'
      },
      filteredGridRows() {
				return this.gridRows.filter((d) => {
					return Object.keys(this.filters).every((f) => {
						return (this.filters[f].length < 1 || this.filters[f].includes(d[f])) && this.isActive ? (d.status == 'active') : true;
					});
				});
			},
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
      // this.getOptions()
    },

    methods: {
      initialize () {
        axios.get('payment/withuserinfo')
          .then(response => {
            this.gridRows = response.data;
            this.loadTable = false;
            // console.log(JSON.stringify(this.gridRows));
          })
          .catch(error => {
            console.log(error)
          });
        axios.get('users')
          .then(response => {
            this.users = response.data;
          })
          .catch(error => {
            console.log(error)
          });
      },

      selectedUser(user) {
        // console.log(JSON.stringify(empl))
        this.editedItem.user_id = user.id
        this.editedItem.lastname = user.lastname
        this.editedItem.firstname = user.firstname
        this.editedItem.phone = user.phone
        this.editedItem.email = user.email
        
        this.dialog2 = false
      },

      required(value) {
        if (value instanceof Array && value.length == 0) {
          return 'Заавал утга оруулна уу.';
        }
        return !!value || 'Заавал утга оруулна уу.';
      },

      formatPrice(value) {
        return value == null || value == "0" ? "-" : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      columnValueList(val) {
				return this.gridRows.map((d) => d[val]);
			},

      editItem (item) {
        this.editedIndex = this.gridRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        if (this.selected.length == 0) {
          alert('Устгах мэдээллийг сонгоно уу.')
          return
        }
        this.editedIndex = this.gridRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        let ids = [];
        this.selected.forEach(function (e) {
            ids.push(e.id);
        });

        axios.delete('payment/' + ids)
          .then(response => {
            alert('Сонгогдсон мэдээллийг амжилттай устгалаа.');
            this.reloadMain()
            this.closeDelete()
          })
          .catch(error => {
            alert('Сонгогдсон мэдээллийг устгахад алдаа гарлаа.');
            console.log(error)
          })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (this.editedIndex > -1) {
          axios.put('payment/' + this.gridRows[this.editedIndex].id, this.editedItem)
            .then(response => {
              alert('Мэдээлэл амжилттай засагдлаа.');
              this.reloadMain();
              // console.log(JSON.stringify(response.data));
            })
            .catch(error => {
              console.log(error)
            })
          // Object.assign(this.gridRows[this.editedIndex], this.editedItem)
        } else {
          axios.post('payment/store', this.editedItem)
            .then(response => {
              alert('Мэдээлэл амжилттай бүртгэж авлаа.');
              this.reloadMain();
              // console.log(JSON.stringify(response.data));
            })
            .catch(error => {
              console.log(error)
            })
          //this.gridRows.push(this.editedItem)
        }
      },
      
      sumField(key) {
        // sum data in give key (property)
        return this.filteredGridRows.reduce((a, b) => Number(a) + (Number(b[key]) || 0), 0)
      },

      reloadMain() {
        this.close();
        this.initialize();
      },

      resetAcctsForm() {
        this.acctsEditedItem = Object.assign({}, this.acctsDefaultItem);
      },
      
      wholePrint: function(mCon) {
        window.print();
      },

    },
  }
</script>